'use strict';

const { unflatten } = require('flat');

const { idTypes, DEFAULT_COHORT } = require('./constants');
const { sha256 } = require('./crypto');

function getCohortId(treatment) {
  // When split.io has an error or a split is unimplemented it returns 'control'.
  // This is a confusing name for experimentation so in these cases we change the name
  // to 'ineligible' https://help.split.io/hc/en-us/articles/360020528072-Control-treatment
  return treatment === 'control' ? DEFAULT_COHORT : treatment;
}

function getSubjectKey({ id, idType }) {
  switch (idType) {
    case idTypes.SHOPPER_ID:
      return sha256(id);
    case idTypes.VISITOR_GUID:
      return id;
    default:
      throw new Error('Invalid subject idType');
  }
}

function getSubjectIdType(trafficType) {
  switch (trafficType) {
    case 'shopper':
      return idTypes.SHOPPER_ID;
    case 'visitor':
      return idTypes.VISITOR_GUID;
    default:
      return trafficType;
  }
}

function treatmentsToCohortAllocations(treatments) {
  const cohortAllocations = {};
  Object.keys(treatments).forEach(splitName => {
    const { treatment, config } = treatments[splitName];

    cohortAllocations[splitName] = {
      cohortId: getCohortId(treatment),
      error: treatment === 'control',
      data: processConfigs(JSON.parse(config) || {})
    };
  });

  return cohortAllocations;
}

function processConfigs(config) {
  // unflatten only on labels. keys
  const labelConfigs = unflatten(Object.keys(config)
    .reduce((obj, key) => {
      if (key.startsWith('labels.')) {
        obj[key] = config[key];
      }
      return obj;
    }, {}));

  // construct object with unflatten labels
  const configsWithAllLabels = { ...config, ...labelConfigs };

  // remove old keys starting with labels.
  return Object.keys(configsWithAllLabels)
    .reduce((obj, key) => {
      if (!key.startsWith('labels.')) {
        obj[key] = configsWithAllLabels[key];
      }
      return obj;
    }, {});
}

function transformSplitToExperiment(split) {
  const experiment = {
    experimentId: split.name,
    subjectIdType: getSubjectIdType(split.trafficType),
    killed: split.killed,
    cohorts: split.treatments,
    cohortData: Object.keys(split.configs).reduce((data, treatment) => {
      data[treatment] = unflatten(JSON.parse(split.configs[treatment]) || {});
      return data;
    }, {})
  };
  const cohortMetadataLabels = Object.values(experiment.cohortData).find(cohortMetadata => cohortMetadata.labels);
  experiment.labels = cohortMetadataLabels ? cohortMetadataLabels.labels : [];
  return experiment;
}

module.exports = {
  getCohortId,
  getSubjectKey,
  getSubjectIdType,
  treatmentsToCohortAllocations,
  transformSplitToExperiment
};
